import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { ComeBack } from '../../components/Onboarding/ComeBack.component';

export const ComeBackPage: React.FC = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const email = params.get('email');

  if (!email) {
    navigate('/404');
    return;
  }

  return <ComeBack email={email} />;
};
